'use strict';

module.exports = {
    moduleType: 'locale',
    name: 'lt',
    dictionary: {},
    format: {
        days: [
            'sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis',
            'ketvirtadienis', 'penktadienis', 'šeštadienis'
        ],
        shortDays: ['sek', 'pir', 'ant', 'tre', 'ket', 'pen', 'šeš'],
        months: [
            'Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis',
            'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'
        ],
        shortMonths: [
            'Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir',
            'Lie', 'Rugp', 'Rugs', 'Spa', 'Lap', 'Gru'
        ],
        date: '%Y-%m-%d'
    }
};
